// extracted by mini-css-extract-plugin
export default {"container":"SearchSelect_container__P3fDm","label":"SearchSelect_label__hhFgL","select":"SearchSelect_select__Vab58"};